import apollo from 'graphql/apollo';
import { createShoppingCartRevisionMutation } from 'graphql/mutations';

const createShoppingCartRevision = async ({ prevCartId, shoppingCart }) =>
  apollo.mutate({
    mutation: createShoppingCartRevisionMutation,
    variables: { prevCartId, shoppingCart },
  });
export default createShoppingCartRevision;
